// import { showDialog } from "vant";
// import { isMobile } from "@/utils/is";
// import { ElMessageBox } from "element-plus";

export const useTokenInvalidation = () => {
  window.location.reload();
  // if (isMobile()) {
  //   showDialog({
  //     title: "登录状态已过期",
  //     message: "您的登录状态已失效，点击下方按钮立即刷新！",
  //   }).then(() => {
  //     window.location.reload();
  //   });
  // } else {
  //   ElMessageBox.alert("验证失效请重新登录！", "系统提示", {
  //     confirmButtonText: "OK",
  //     callback: () => {
  //       window.location.reload();
  //     },
  //   });
  // }
};
